import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function Footer() {
  return <footer className="bg-dark-900 pt-12 pb-8 border-t border-dark-800" data-id="element-57">
      <div className="container mx-auto px-6" data-id="element-58">
        <motion.div className="max-w-3xl mx-auto bg-dark-800/30 rounded-2xl p-6 md:p-8 border border-dark-700/50 flex items-start gap-4" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-59">
          <AlertCircle className="w-6 h-6 text-brand-muted shrink-0 mt-1" data-id="element-60" />
          <div data-id="element-61">
            <h4 className="font-heading text-xl tracking-wide mb-2" data-id="element-62">
              Nota importante para tu bienestar
            </h4>
            <p className="text-sm text-brand-muted leading-relaxed font-light" data-id="element-63">
              Este material es un recurso de apoyo emocional y educativo. No
              sustituye el diagnóstico ni el tratamiento de un profesional de la
              salud mental. Si te encuentras en una situación de crisis grave,
              te instamos a contactar de inmediato con especialistas o líneas de
              ayuda local.
            </p>
          </div>
        </motion.div>

        <div className="mt-16 text-center text-brand-muted/50 text-sm font-light" data-id="element-64">
          <p data-id="element-65">
            © {new Date().getFullYear()} Proyecto ARCA. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}